import { OpenAPIRegistry, extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
import { z, ZodTypeDef, ZodTypeAny, ZodRawShape } from 'zod';

// Apply type assertion to fix "Type instantiation is excessively deep and possibly infinite" error
// @ts-ignore
extendZodWithOpenApi(z as any);

declare module 'zod' {
    interface ZodType<Output, Def extends ZodTypeDef = ZodTypeDef, Input = Output> {
        openapi(options: any): this;
    }
    interface ZodObject<T extends ZodRawShape> {
        openapi(options: any): this;
    }
    interface ZodArray<T extends ZodTypeAny> {
        openapi(options: any): this;
    }
    interface ZodOptional<T extends ZodTypeAny> {
        openapi(options: any): this;
    }
    interface ZodNullable<T extends ZodTypeAny> {
        openapi(options: any): this;
    }
    /*
    interface ZodUnion<T extends ZodTypeAny[]> {
        openapi(options: any): this;
    }
    */
    interface ZodEnum<T extends [string, ...string[]]> {
        openapi(options: any): this;
    }
}

// Create a wrapped version of z with proper typing for OpenAPI extensions
type EnhancedZod = typeof z & {
    // Add missing openapi method to all Zod types
    ZodString: typeof z.ZodString & { prototype: { openapi: any } };
    ZodNumber: typeof z.ZodNumber & { prototype: { openapi: any } };
    ZodBoolean: typeof z.ZodBoolean & { prototype: { openapi: any } };
    ZodArray: typeof z.ZodArray & { prototype: { openapi: any } };
    ZodObject: typeof z.ZodObject & { prototype: { openapi: any } };
    ZodEnum: typeof z.ZodEnum & { prototype: { openapi: any } };
    ZodUnion: typeof z.ZodUnion & { prototype: { openapi: any } };
    ZodOptional: typeof z.ZodOptional & { prototype: { openapi: any } };
    ZodNullable: typeof z.ZodNullable & { prototype: { openapi: any } };
    ZodAny: typeof z.ZodAny & { prototype: { openapi: any } };
};

// Export the z instance (which is now extended)
export { z };

// Create and export the registry
export const registry = new OpenAPIRegistry();

// Add a helper function to register schemas with proper type assertions
export function registerSchema(name: string, schema: any) {
    return registry.register(name, schema as any);
}
